'use client';

import * as React from 'react';
import { Switch as BaseSwitch } from '@base-ui/react/switch';
import styles from './Switch.module.css';
import clsx from 'clsx';

export interface SwitchProps {
  checked?: boolean;
  defaultChecked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  label?: string;
  description?: string;
  name?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  /** Accessible name when no visible `label` is rendered. */
  'aria-label'?: string;
}

export const Switch = React.forwardRef<HTMLButtonElement, SwitchProps>(
  (
    {
      checked,
      defaultChecked,
      onChange,
      disabled = false,
      label,
      description,
      name,
      size = 'md',
      className,
      'aria-label': ariaLabel,
    },
    ref
  ) => {
    return (
      <div className={clsx(styles.container, className)}>
        <label className={clsx(styles.label, disabled && styles.disabled)}>
          <BaseSwitch.Root
            ref={ref}
            checked={checked}
            defaultChecked={defaultChecked}
            onCheckedChange={onChange}
            disabled={disabled}
            name={name}
            aria-label={ariaLabel}
            className={clsx(styles.switch, styles[size])}
          >
            <BaseSwitch.Thumb className={styles.thumb} />
          </BaseSwitch.Root>
          {label && (
            <span className={styles.labelText}>
              {label}
              {description && <span className={styles.description}>{description}</span>}
            </span>
          )}
        </label>
      </div>
    );
  }
);

Switch.displayName = 'Switch';
